import { defineComponent } from 'vue';
import SButton from '@/components/stemdo-components/s-button/SButton.vue';
import SModalCentered from '@/components/stemdo-components/s-modal-centered/SModalCentered.vue';
import { useI18N } from '@/plugins/i18n';
import { IExperience } from '@/shared/model/experience.model';

export default defineComponent({
  props: {
    onSuccess: {
      type: Function,
      required: true
    },
    experience: {
      type: Object as () => IExperience,
      required: true
    },
    isOpen: {
      type: Boolean,
      required: true
    },
    onClose: {
      type: Function,
      required: true
    }
  },
  components: {
    SButton,
    SModalCentered
  },
  setup(props) {
    const customModalProps = { bodyPaddingY: 0, fullWidthFooter: true };
    const i18n = useI18N();

    const handleClose = () => {
      props.onClose();
    };
    const handleAccept = () => {
      // Aquí simplemente llamamos al callback de borrado
      props.onSuccess();
    };

    return {
      customModalProps,
      handleClose,
      handleAccept
    };
  }
});
